import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const includedItems = ['rutina de revisión por la mañana', 'rutina de revisión por la noche', 'pasos simples de higiene diaria', 'recomendaciones para mayor comodidad', 'consejos para elegir mejor calcetines y calzado', 'hábitos que conviene evitar', 'checklist diario', 'checklist semanal', 'checklist de confort', 'plan personal de autocuidado'];
export function Includes() {
  return <section className="py-20 bg-cream-dark/30" data-id="element-214">
      <div className="max-w-5xl mx-auto px-6" data-id="element-215">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-216">
          <h2 className="text-3xl md:text-4xl font-serif mb-4" data-id="element-217">
            Dentro de tu guía encontrarás:
          </h2>
          <div className="w-16 h-[1px] bg-bronze mx-auto" data-id="element-218" />
        </motion.div>

        <div className="grid md:grid-cols-2 gap-x-12 gap-y-6 max-w-4xl mx-auto" data-id="element-219">
          {includedItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-4 p-4 bg-white rounded-sm shadow-sm border border-cream-dark" data-id="element-220">
              <CheckCircle2 className="w-6 h-6 text-bronze shrink-0 mt-0.5" data-id="element-221" />
              <span className="text-charcoal-light font-medium" data-id="element-222">{item}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}